export default "__VITE_ASSET__BqCMPy9F__"